import { Stack } from "@mui/material";

const FormLayoutVertical = props => <Stack spacing={6} {...props} />;

export default FormLayoutVertical;
